module.exports = __webpack_public_path__ + "img/emoji.2dfa9ae1.png";